import React from 'react';

import { useParams } from 'react-router';

import ErrorScreen from 'components/shared/ErrorScreen';
import * as itinerariesItemThunks from 'store/itinerariesItem/thunks';

import Preview from '../shared/Preview';
import s from './index.module.css';

function PreviewPage() {
  const params = useParams<{ itemType: string; itemId: string }>();
  const itemType = params.itemType;
  const itemId = params.itemId;

  const previewRequest = (() => {
    if (itemType === 'lookbook') return itinerariesItemThunks.fetchSampleLookBookItemThunk;
    if (itemType === 'itinerary') return itinerariesItemThunks.fetchSampleItinerariesItemThunk;
    if (itemType === 'guest_portal') return itinerariesItemThunks.fetchGuestPortalThunk;

    return;
  })();

  if (!previewRequest || !itemType || !itemId) {
    console.error('Could not open PreviewPage');
    return <ErrorScreen status="404" />;
  }

  return (
    <Preview
      pageId={itemId}
      getIsSamplePreview={() => true}
      fetchData={previewRequest}
      modalWrapperClassName={s.modalWrapperClassName}
    />
  );
}

export { PreviewPage };
